export default function(instance) {
  return {
    getAnalytics() {
      return instance.get("/api/analytics/");
    }
  };
}
